import type { FaireProductEntity } from "../../entity_types/product";

export const p_44m5eburmk: FaireProductEntity = {
  token: "p_44m5eburmk",
  type: "product",
  name: "Button Front Vest Blazer Top",
  brandToken: "b_nd6psatxbw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b025f597aa43ec87766df4c0ba7e596bb13f0f7b9b801090d4cf8c2545afb90b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0b75a4ffe8df18a6ee16a1d6480b256252f0072cd3ec66f5dff93cd2f8faf11.jpeg",
    "https://cdn.faire.com/fastly/7b00211bf79bb4f500ef56eab5840cd9778118bf9d43a067dd059261a9153f95.jpeg",
  ],
  priceDollars: 24.57,
  description:
    "A tailored vest designed with a structured blazer-style collar and refined button-front detailing. Featuring a sleek silhouette and polished finish, this versatile piece is perfect for office wear and modern boutique collections.\n\nMaterial: Polyester\nWeight: 0.52 kg\n",
  tags: [],
  msrpDollars: 49.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:30:25.872Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
